import gql from "graphql-tag";

export const List = gql`
  query ListEvents (
    $filter: TableEventFilterInput, 
    $limit: Int,
    $nextToken: String
  )
  {
    listEvents(filter: $filter, limit: $limit, nextToken: $nextToken) { 
      items {
        id
        title
        beginDate
        endDate
        location
        registrationEnabled
        published
        i18n_description
        type
        createdBy
        createdAt
      }
    }
  }
`;

export const Create = gql`
  mutation CreateEvent($input: CreateEventInput!) {
    createEvent(input: $input) {
      title
      beginDate
      endDate
      location
      registrationEnabled
      published
      i18n_description
      type
    }
  }
`;

export const Update = gql`
  mutation UpdateEvent($input: UpdateEventInput!) {
    updateEvent(input: $input) {
      id
      title
      beginDate
      endDate
      location
      registrationEnabled
      published
      i18n_description
    }
  }
`;



// WEBPACK FOOTER //
// ./src/private/admin/containers/Events/graphql.js